import { render, staticRenderFns } from "./CameraIcon.vue?vue&type=template&id=3273d980"
import script from "./CameraIcon.vue?vue&type=script&lang=js"
export * from "./CameraIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports